import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var dtrum: any;
export abstract class BaseComponent {
	public isDestroyed: boolean;
	private _obsComplete: Subject<void> = new Subject<void>();

	public setDynatraceEvent(eventName: string) {
		if (!window.hasOwnProperty('dtrum')) return;
		let eventVal: any = dtrum.enterAction(eventName);
		dtrum.leaveAction(eventVal);
	}

	public enterDynatraceEvent(eventName: string) {
		if (!window.hasOwnProperty('dtrum')) return;
		let eventVal: any = dtrum.enterAction(eventName);
		return eventVal;
	}

	public leaveDynatraceEvent(eventVal: any) {
		if (!window.hasOwnProperty('dtrum')) return;
		dtrum.leaveAction(eventVal);
	}

	public mortalize<T>(obs: Observable<T>) {
		return obs.pipe(takeUntil(this._obsComplete));
	}

	protected ngOnDestroy() {
		this._obsComplete.next();
		this._obsComplete.complete();
		this.isDestroyed = true;
	}
}
